import React from 'react';
import PageHeader from '../../components/PageHeader';

function Privacy() {
  return (
    <>
      <PageHeader title="Privacy Policy" subtitle="Last updated: 2026-05-08" />
      <div className="card prose">
        <h3>What we collect</h3>
        <ul>
          <li>Account information (name, email, phone).</li>
          <li>Health screening info (BMI, contraindications, lifestyle answers).</li>
          <li>Booking information (clinic, schedule, payment, attendance).</li>
          <li>Progress data (weight, photos uploaded by you or your clinic).</li>
          <li>Operational metadata (IP address, device, audit logs).</li>
        </ul>

        <h3>How we use it</h3>
        <ul>
          <li>Match you with appropriate clinics.</li>
          <li>Coordinate medical bookings and payments.</li>
          <li>Track outcomes and clinic performance.</li>
          <li>Detect fraud and abuse (including referral fraud).</li>
        </ul>

        <h3>Sharing</h3>
        <p>
          We share medical and contact information with the clinic you select
          so they can provide care. We do not sell your data. Aggregated,
          de-identified analytics may be shared with research partners.
        </p>

        <h3>Storage & retention</h3>
        <p>
          Health information is stored encrypted at rest. Booking records are
          retained per Malaysian medical-record retention requirements.
          Account closure removes your profile but legally required records
          are retained.
        </p>

        <h3>Your rights</h3>
        <p>
          You can request access, correction, or deletion of your personal
          data, subject to legal retention requirements. Contact us through
          your account settings.
        </p>
      </div>
    </>
  );
}

export default Privacy;
